<script>
import adminTable from './mixins/adminTable'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default
{

    mixins: [ adminTable ],

    computed: {
        ...mapGetters({
            artists: 'artistList',
            locations: 'locationList',
        })
    },

    methods:
    {
        fetch() {
          axios.get(process.env.API_URL + this.url).then(res => {
            this.data = res.data
            this.data.map((el) => {
              if (el && el.program) {
                el.start = el.program.start
                el.location = el.program.location
                el.location_name = el.program && el.program.location ? el.program.location.name : ''
                el.location_id = el.program.location_id
                el.name = el.program.name
                el.artists = el.program.artists
                el.slug = el.program.slug
                el.end = el.program.end
              }
              return el
            })
            this.updateData()
          }).catch(e => {})
        },

        applyArtistFilter(artist)
        {
            this.$store.commit(this.tableName + '/SET_CUSTOM_FILTER', {filter: 'artists', value: artist})
        },

        applyLocationFilter(location)
        {
            this.$store.commit(this.tableName + '/SET_CUSTOM_FILTER', {filter: 'location', value: location})
        },

        applyStartFilter(start)
        {
            this.$store.commit(this.tableName + '/SET_CUSTOM_FILTER', {filter: 'start', value: start})
        },

        fetchDates()
        {
            axios.get(process.env.API_URL + '/v1/dates').then(res => {
                this.dates = res.data.dates
            })
        },
    },

    data()
    {
        return {
            data: [],
            dates: [],
            url: '/v1/admin/recommendations',
            tableName: 'tableRecommendations',
            emptyModel: { program_id: null, top: false },
            columns: [ 'id', 'name', 'artists', 'start', 'location_name', 'actions'],
            options: {
                headings: {
                    name: this.$t('GENERAL.TITLE'),
                    actions: this.$t('TABLE.ACTIONS'),
                    start: this.$t('PROGRAM.START'),
                    artists: this.$t('PROGRAM.ARTIST'),
                    location_name: this.$t('PROGRAM.LOCATION'),
                },
                perPage: 50,
                perPageValues: [10, 25, 50, 100, 200, 400],
                saveState: true,
                highlightMatches: true,
                filterByColumn: true,
                columnsDropdown: true,
                toMomentFormat: true,
                customFilters: [{
                        name: 'artists',
                        callback: function(row, query) {
                            if (row.program && row.program.artists)
                            {
                                for (let i = 0; i < row.program.artists.length; ++i)
                                {
                                    if (row.program.artists[i].id == query.id)
                                        return true;
                                }
                            }
                            return false
                        }
                    }, {
                        name: 'location',
                        callback: function(row, query) {
                            if (row.program && row.program.location && row.program.location.name)
                            {
                                if (row.program.location.name.indexOf(query.name) !== -1)
                                    return true;
                            }
                            return false
                        }
                    }, {
                        name: 'start',
                        callback: function(row, query) {
                            if (row.program && row.program.start)
                            {
                                if (row.program.start.indexOf(query) !== -1)
                                    return true;
                            }
                            return false
                        }
                    },
                ]
            }
        }
    },

    mounted()
    {
        this.fetchDates()
    },
}
</script>

<template>
    <div class="container-fluid">
        <div class="form-group row">
            <label for="name" class="col-md-2 control-label text-left">
                {{ $t('PROGRAM.ARTIST') }}
            </label>
            <div class="col-md-4">
                <v-select :options="artists" label="name" @input="applyArtistFilter">

                </v-select>
            </div>
            <label for="name" class="col-md-2 control-label text-left">
                {{ $t('PROGRAM.LOCATION') }}
            </label>
            <div class="col-md-4">
                <v-select :options="locations" label="name" @input="applyLocationFilter">

                </v-select>
            </div>
        </div>
        <div class="form-group row">
            <label for="name" class="col-md-2 control-label text-left">
                {{ $t('PROGRAM.START') }}
            </label>
            <div class="col-md-4">
                <v-select :options="dates" label="name" @input="applyStartFilter">

                </v-select>
            </div>
        </div>
        <mv-modal ref="form">
            <span slot="header">{{ $t('GENERAL.EDIT') }}</span>
            <mv-recommendation-form :model="model" :edit="formEdit" @save="fetch"></mv-recommendation-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm" v-if="formEdit">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.PROGRAMS') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="name" slot-scope="props">
                        <template v-if="props.row.program && props.row.program.name">
                            {{ props.row.program.name }}
                        </template>
                    </div>
                    <div slot="location_name" slot-scope="props">
                        <template v-if="props.row.program && props.row.program.location && props.row.program.location.name">
                            {{ props.row.program.location.name }}
                        </template>
                    </div>
                    <div slot="start" slot-scope="props">
                        <template v-if="props.row.program && props.row.program.start">
                            {{ props.row.program.start }}
                        </template>
                    </div>
                    <div slot="artists" slot-scope="props">
                        <div v-if="props.row.program && props.row.program.artists" v-for="artist in props.row.program.artists" :key="artist.id">
                            <div>
                                <img v-if="artist.attachments && artist.attachments.length > 0" :src="artist.attachments[0].thumbnail_url">
                                <div class="label label-primary">
                                    {{ artist.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Recommendations.vue